import type { SxProps } from "@mui/material";

import Alert from "@rui/Alert";
import {
  EmptyStateContainer,
  EmptyStateErrorIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import { Row } from "@rui/Stack";

const BillingModuleError = ({
  entityLabel,
  sx,
  type = "alert",
}: {
  entityLabel: string;
  sx?: SxProps;
  type?: "alert" | "overlay";
}) => {
  if (type === "overlay") {
    return (
      <EmptyStateContainer sx={sx}>
        <EmptyStateErrorIcon />
        <EmptyStateTitle>Unable to load your {entityLabel}</EmptyStateTitle>
        <EmptyStateSubtext>
          Please refresh the page or contact support@read.ai if the problem
          persists.
        </EmptyStateSubtext>
      </EmptyStateContainer>
    );
  }

  return (
    <Row sx={sx}>
      <Alert severity="error" embedded>
        Unable to load your {entityLabel}. Please refresh the page or contact
        support@read.ai if the problem persists.
      </Alert>
    </Row>
  );
};

export default BillingModuleError;
